import L from "react";
import { q as S } from "./index.CVakAlTX.js";
import l from "swr";
import { API_BASE_LANG as N, API_BASE_URL as d } from "../constants/requests/index.js";
import { u as A } from "./use-sitecore-context.C7g4vcbm.js";
const I = "6", E = "1", P = "suggestlocationname", f = `locations/${P}`, T = () => {
  var o, n, m, e, u;
  const { sitecoreContext: a } = A(), r = (o = a == null ? void 0 : a.route) != null && o.itemId ? `{${(n = a == null ? void 0 : a.route) == null ? void 0 : n.itemId}}` : "", _ = ((m = a == null ? void 0 : a.site) == null ? void 0 : m.name) ?? "", g = (a == null ? void 0 : a.language) ?? N, [s, i] = L.useState(null), p = {
    locationName: s,
    pageId: r,
    sc_lang: g,
    sc_site: _,
    display: I,
    page: E
    // Default to the first page
  }, t = l(
    s ? [`${d}${f}?${S.stringify({ ...p })}`] : null
  );
  return {
    ...t,
    typeaheadItems: ((u = (e = t.data) == null ? void 0 : e.data) == null ? void 0 : u.map((c) => ({
      id: c,
      value: c,
      data: {}
    }))) ?? [],
    setLocationName: i
  };
};
export {
  I as S,
  E as a,
  P as b,
  f as c,
  T as u
};
